module.exports = __webpack_public_path__ + "img/Grid_Skull_nonsquare@2x.46f470bc.png";